import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.474 11.525a6.4 6.4 0 1 1 9.051-9.05 6.4 6.4 0 0 1-9.05 9.05m3.394-6.788a.8.8 0 0 0-1.131 1.131L5.868 7 4.737 8.13a.8.8 0 0 0 1.131 1.132L7 8.13 8.13 9.263A.8.8 0 1 0 9.262 8.13L8.132 7l1.13-1.132a.8.8 0 0 0-1.13-1.13L7 5.867z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })